import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authCodeFlowConfigForB2E: AuthConfig = {
  issuer: environment.b2e.issuer,
  redirectUri: environment.b2e.redirectUri,
  clientId: environment.b2e.clientId,
  responseType: environment.b2e.responseType,
  scope: environment.b2e.scope,
  requireHttps: environment.b2e.requireHttps,
  oidc: true,
  showDebugInformation: environment.b2e.showDebugInformation,
};
